import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, timeout, catchError } from 'rxjs/operators';
import { BaseHttpService } from '../../http/base-http.service';
import { EndPointService } from '../../http/end-point.service';
import { ModuleConstants, Constants } from '../../constants/constants';
import { StorageProvider } from '../../http/storage-service';
import { CommonUtilsService } from '../utils/common-utils.service';

@Injectable({
  providedIn: 'root'
})
export class UserInfoService {
  userData: any;

  constructor(private baseHttp: BaseHttpService, private endpoint: EndPointService,
              private storageProvider: StorageProvider, private commonUtilsProvider: CommonUtilsService) {

  }

  /**
   * Function will get menu mapping event lookup data
   */
  getMenuMapping(): Observable<{}> {
    return this.baseHttp.get(this.endpoint.getMenuMapping)
      .pipe(
        timeout(ModuleConstants.apiTimeout),
        map((res) => this.commonUtilsProvider.extractData(res)),
        catchError((err) => this.commonUtilsProvider.catchError(err))
      );
  }


  /**
   * Sets logged in user details
   * @param userData : logged in data
   */
  setLoggedInUserDetails(userData) {
    this.userData = userData;
    this.storageProvider.setSessionStorageData(Constants.LoggedInUserData, userData);
  }

  /**
   * Gets logged in user details
   * @returns : object
   */
  getLoggedInUserDetails() {
    if (this.userData == null) {
      this.userData = this.storageProvider.getSessionStorageData(Constants.LoggedInUserData);
    }
    return this.userData;
  }

  /**
   * Removes storage data
   * @param key: key to be removed
   */
  removeStorageData(key) {
    this.storageProvider.removeKeys(key);

  }
}
